export default class MemoryStorage {
  constructor () {
    this.onclose = () => {
    }

    this.data = {}
    this.models = [
      {name: 'people'},
      {name: 'relationships'},
      {name: 'positions'},
      {name: 'departments'},
      {name: 'organisations'},
      {name: 'logentries'},
      {name: 'educations'},
      {name: 'settings'}
    ]
  }

  open () {
    return new Promise((resolve, reject) => {
      let modelCount = 0
      this.models.forEach((model) => {
        this.create(model).then(() => {
          modelCount++

          if (modelCount === this.models.length) {
            resolve()
          }
        }, reject)
      })
    })
  }

  status () {
    return new Promise((resolve) => {
      resolve('new')
    })
  }

  close () {
    this.onclose()
  }

  create (model) {
    return new Promise((resolve) => {
      this.data[model.name] = {}
      resolve()
    })
  }

  readModel (model) {
    return new Promise((resolve, reject) => {
      if (this.data[model.name]) {
        resolve(this.data[model.name])
      } else {
        reject()
      }
    })
  }

  get (model, id) {
    return new Promise((resolve, reject) => {
      if (this.data[model.name] && this.data[model.name][id]) {
        resolve(this.data[model.name][id])
      } else {
        reject()
      }
    })
  }

  put (model, data) {
    return new Promise((resolve, reject) => {
      if (!this.data[model.name]) {
        reject()
      }

      if (!data.id) {
        data.id = window.PRIM.getUUID()
      }

      this.data[model.name][data.id] = data
      resolve()
    })
  }

  delete (model, id) {
    return new Promise((resolve, reject) => {
      if (this.data[model.name] && this.data[model.name][id]) {
        delete this.data[model.name][id]
        resolve()
      } else {
        reject()
      }
    })
  }

  writeModel (model, data) {
    return new Promise((resolve) => {
      this.data[model.name] = data
      resolve()
    })
  }

  read () {
    return new Promise((resolve, reject) => {
      let data = {}
      let modelCount = 0

      this.models.forEach((model) => {
        this.readModel(model).then((modelData) => {
          this.data[model.name] = modelData

          modelCount++

          if (modelCount === this.models.length) {
            resolve(data)
          }
        }, reject)
      })
    })
  }

  write (data) {
    return new Promise((resolve, reject) => {
      let dataCount = 0

      this.models.forEach((model) => {
        let totalCount = Object.keys(data[model.name]).length

        if (totalCount > 0) {
          for (let id in data[model.name]) {
            let entry = data[model.name][id]
            this.writeModel(model, entry).then(() => {
              dataCount++

              if (dataCount === totalCount) {
                resolve()
              }
            }, reject)
          }
        } else {
          resolve()
        }
      })
    })
  }

  destroy () {
    this.data = null
    this.init()
  }
}



// WEBPACK FOOTER //
// ./js/lib/storage/MemoryStorage.js